import React from 'react'

import style from './Trigger.module.scss'
import { withObserver } from '~contexts/ObserverContext'

const Trigger = ({
  children,
  trigger,
  option='',
  value='',
}) => {
  const triggerEvent = () => {
    trigger(option, value)
  }

  return (
    <div onClick={triggerEvent} className={style.trigger}>
      {children}
    </div>
  )  
}

export default withObserver(Trigger)